import Ardea1 from '../../../media/Residentials/Ardea/Ardea.webp'
import Ardea2 from '../../../media/Residentials/Ardea/Ardea (2).webp'
import Ardea3 from '../../../media/Residentials/Ardea/Ardea (3).webp'
import Ardea4 from '../../../media/Residentials/Ardea/Ardea (4).webp'
import Ardea5 from '../../../media/Residentials/Ardea/Ardea (5).webp'
import Ardea6 from '../../../media/Residentials/Ardea/Ardea (6).webp'
import Ardea7 from '../../../media/Residentials/Ardea/Ardea (7).webp'
import Ardea8 from '../../../media/Residentials/Ardea/Ardea (8).webp'
import Ardea9 from '../../../media/Residentials/Ardea/Ardea (9).webp'
import Ardea10 from '../../../media/Residentials/Ardea/Ardea (10).webp'
import Ardea11 from '../../../media/Residentials/Ardea/Ardea (11).webp'
import Ardea12 from '../../../media/Residentials/Ardea/Ardea (12).webp'

const Ardeaimages =[
Ardea1,Ardea2,Ardea3,Ardea4,Ardea5,Ardea6,Ardea7,Ardea8,Ardea9,Ardea10,Ardea11,Ardea12
]

export default Ardeaimages;